export default __webpack_public_path__ + "static/media/TTFInfo.73e7fe82.md";